import React, { ChangeEvent } from 'react'
import { useRouter } from 'next/router'

import { useAppSelector } from '#/app/store/store'
import { makePrivateRequest } from '#/shared/api'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

import { sendReport } from '../api'

const MAX_FILE_SIZE = 4.5 * 1024 * 1024 // 4.5 MB

export const useErrorReport = () => {
	const email = useAppSelector((state) => state.user.email)
	const [file, setFile] = React.useState<File>()

	const { showMessage } = useShowDataStore()
	const [errorMessage, setErrorMessage] = React.useState<string>('')
	const [error, setError] = React.useState(false)

	const [isSend, setIsSend] = React.useState(false)
	const router = useRouter()

	const handleGoBackPage = () => {
		router.back()
	}

	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (e.target.files) {
			if (MAX_FILE_SIZE > e.target.files[0].size){
				setFile(e.target.files[0])
			} else {
				showMessage('Файл должен быть меньше  4.5 MB')
			}
		}
	}

	const sendError = makePrivateRequest(async () => {
		if (errorMessage.trim() === '') {
			showMessage('Поле не должно быть пустым.')
			setError(true)
			setTimeout(() => setError(false), 3000)
			return
		}

			const response = await sendReport({ errorMessage, email, file })
			
			if (response.status === 201) {
				setErrorMessage('')
				setIsSend(true)
				setTimeout(() => {
					setIsSend(false)
				}, 5000)
			}

			if (response.status >= 400 && response.status < 500 && response?.data?.detail) {
				showMessage(String(response.data.detail))
			}

	})

	return {
		isSend,
		setErrorMessage,
		handleFileChange,
		file,
		setFile,
		sendError,
		error,
		handleGoBackPage,
	}
}
